import { Button, PopoverMenu } from '@factorialco/deprecated-design-system'

import VisibilityPopoverContent from './VisibilityPopoverContent'

const VisibilityPopover = () => {
  return (
    <PopoverMenu type="list">
      <PopoverMenu.Trigger>
        <Button type="secondary" iconName={'eye-visible'} />
      </PopoverMenu.Trigger>
      <PopoverMenu.Content
        side="bottom"
        align="start"
        width="s300"
        paddingBottom="s0"
        paddingTop="s0"
      >
        <VisibilityPopoverContent />
      </PopoverMenu.Content>
    </PopoverMenu>
  )
}

export default VisibilityPopover
